import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminSubscribers from './subscriptions/AdminSubscribers';

const AdminSubscribersPage = () => (
  <AdminLayout>
    <AdminSubscribers />
  </AdminLayout>
);

export default AdminSubscribersPage;
